import { useCallback, useState } from "react";
import summarizePrescription from "../api/deepseek";
import useOkhatiAiSettings, { isDeepSeekReady } from "./useOkhatiAiSettings";

export default function usePrescriptionSummary(): {
  summarize: (transcript: string) => Promise<string>;
  isSummarizing: boolean;
  error: string | null;
  isDeepSeekReady: boolean;
} {
  const settings = useOkhatiAiSettings();
  const [isSummarizing, setIsSummarizing] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const summarize = useCallback(async (transcript: string): Promise<string> => {
    setIsSummarizing(true);
    setError(null);

    try {
      return await summarizePrescription(transcript);
    } catch (err) {
      const message =
        err instanceof Error ? err.message : "Failed to generate prescription summary";
      setError(message);
      throw err;
    } finally {
      setIsSummarizing(false);
    }
  }, []);

  return {
    summarize,
    isSummarizing,
    error,
    isDeepSeekReady: isDeepSeekReady(settings)
  };
}
